<template>
  <div
    class="home-camera"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div
      id="home-player"
      :style="{ backgroundImage: playing ? 'none' : `url(${cover})` }"
    ></div>

    <div class="home-camera-mask" v-if="!playing && !loading && Boolean(devKey)">
      <el-button
        circle
        icon="el-icon-caret-right"
        class="center-button"
        @click="readyPlay"
      >
      </el-button>
    </div>
  </div>
</template>

<script>
import EZUIKit from '@/assets/js/ezuikit'
import { getAddress, getCover } from '@/service/camera'
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'
import sleep from '@/utlis/sleep'

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    devs: Array
  },
  computed: {
    devKey() {
      return this.devs && this.devs[0] ? this.devs[0] : ''
    }
  },
  data() {
    return {
      loading: false,
      playing: false,
      address: [],
      actived: '',
      cover: '',
      token: '',
      decoder: null
    }
  },
  beforeDestroy() {
    if (this.decoder) {
      removeResizeListener(this.$el, this.resizeHandler)
      this.decoder.stop(0)
      this.decoder.destroy()
    }
  },
  mounted() {
    addResizeListener(this.$el, this.resizeHandler)
  },
  methods: {
    async getActived(key) {
      if (key) {
        this.loading = true
        const [{ data: cover }, { data }] = await Promise.all([
          getCover(key),
          getAddress(this.companyId),
          sleep(1)
        ])
        this.cover = cover.cover
        this.address = data.cameras.find(a => a.key === key)
        this.token = data.token
        this.loading = false
      }
    },
    handleSuccess() {
      this.isStop = false
      if (this.isReplay) {
        if (this.processer) {
          clearInterval(this.processer)
        }
        this.processer = setInterval(this.setTime, 1000)
      }
    },
    handleError() {
      this.$message.error({
        message: '加载监控失败，请稍后重试或联系管理员'
      })
      this.isReady = false
      if (this.isReplay) {
        if (this.processer) {
          clearInterval(this.processer)
        }
      }
    },
    initPlay() {
      this.loading = true
      const width = this.$el.offsetWidth - 24
      const height = this.$el.offsetHeight - 24
      const url = this.address.live

      if (this.devKey) {
        this.decoder = new EZUIKit.EZUIPlayer({
          id: 'home-player',
          autoplay: false,
          url: url,
          accessToken: this.token,
          decoderPath: process.env.NODE_ENV === 'production' ? '/v3' : '',
          width,
          height,
          splitBasis: 1,
          onLoaded: () => {
            this.playing = true

            this.decoder &&
              this.decoder.play({
                handleError: this.handleError,
                handleSuccess: this.handleSuccess
              })

            setTimeout(() => {
              this.loading = false
            }, 2 * 1000)
          }
        })
      }
    },
    resizeHandler() {
      const width = this.$el.offsetWidth - 24
      const height = this.$el.offsetHeight - 24
      this.decoder && this.decoder.reSize(width, height)
    },
    readyPlay() {
      this.initPlay()
    }
  },
  watch: {
    devKey(key) {
      this.getActived(key)
    }
  }
}
</script>

<style lang="scss">
.home-camera {
  padding: 12px;
  height: 100%;
  width: 50%;
  box-sizing: border-box;
  position: relative;
  // background-color: rgba(0, 0, 0, 0.3);
  #home-player {
    width: 100%;
    height: 100%;
    background-color: #000;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // z-index: 100000;
  }
  .home-camera-mask {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    width: 100%;
    height: 100%;
    user-select: none;
    justify-content: center;
    align-items: center;
    // pointer-events: none;
  }

  .center-button {
    font-size: 1.2rem;
  }
}
</style>
